module.exports = __webpack_public_path__ + "img/WTA-Player-Zone_Headers.0929e299.png";